import { LayoutDashboard, MessageSquare, BookOpen, Zap, Ticket, Users, Brain } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { cn } from "@/lib/utils";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

const adminItems = [
  { title: "Dashboard", url: "/admin/dashboard", icon: LayoutDashboard },
  { title: "Conversas", url: "/admin/conversas", icon: MessageSquare },
  { title: "Conhecimento", url: "/admin/conhecimento", icon: BookOpen },
  { title: "Treinamentos", url: "/admin/treinamentos", icon: Brain },
  { title: "Pipelines", url: "/admin/pipelines", icon: Zap },
  { title: "Leads", url: "/admin/leads", icon: Users },
  { title: "Convites", url: "/admin/convites", icon: Ticket },
];

export function AppSidebar() {
  const { state } = useSidebar();
  const location = useLocation();
  const { user } = useAuth();
  const collapsed = state === "collapsed";
  const isSuperAdmin = user?.role === "SUPER_ADMIN";

  function isActive(url: string): boolean {
    return location.pathname === url || location.pathname.startsWith(url + "/");
  }

  return (
    <Sidebar className={collapsed ? "w-16" : "w-56"} collapsible="icon">
      <SidebarContent className="pt-6 bg-card border-r border-border">
        {/* Brand */}
        <div className={`px-4 mb-8 ${collapsed ? "px-2" : ""}`}>
          <div className="flex items-center gap-2.5">
            <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center shrink-0">
              <span className="text-primary-foreground text-sm font-bold leading-none select-none">V</span>
            </div>
            {!collapsed && (
              <div className="leading-none">
                <p className="text-sm font-bold text-foreground tracking-tight leading-none">VTSD</p>
                <p className="text-[11px] text-muted-foreground leading-none mt-0.5">Central de Suporte</p>
              </div>
            )}
          </div>
        </div>

        <SidebarGroup>
          <SidebarGroupLabel className={`${collapsed ? "px-2" : ""} text-xs text-muted-foreground/70 uppercase tracking-wider`}>
            {!collapsed && "Admin"}
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {adminItems.map((item) => {
                if (item.url === "/admin/convites" && !isSuperAdmin) return null;
                const active = isActive(item.url);
                return (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild>
                      <Link
                        to={item.url}
                        className={cn(
                          "flex items-center gap-3 rounded-lg px-3 py-2.5 transition-all text-muted-foreground hover:bg-sidebar-accent",
                          active && "bg-primary/10 text-primary font-medium"
                        )}
                      >
                        <item.icon className="h-[18px] w-[18px] flex-shrink-0" />
                        {!collapsed && <span className="text-sm">{item.title}</span>}
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
